export default "__VITE_ASSET__BRHFl21y__"